"use client";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

export default function PackageDetails({ slug }) {
  const [packageData, setPackageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPackage = async () => {
      try {
        const response = await fetch("/api/packages");
        if (response.ok) {
          const data = await response.json();
          if (data && Array.isArray(data)) {
            const foundPackage = data.find(
              (p) => p.title.toLowerCase().replace(/\s+/g, "-") === slug,
            );
            if (foundPackage) {
              setPackageData(foundPackage);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching package data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchPackage();
    }
  }, [slug]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "80vh", width: "100%" }}
      >
        <div
          className="spinner-border"
          role="status"
          style={{
            color: "var(--theme-color, #F55B1F)",
            width: "3rem",
            height: "3rem",
          }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!packageData) {
    return <div className="text-center py-5">Package not found</div>;
  }

  const whyoptions = [
    {
      id: 1,
      icon: "/assets/img/icon-1.png",
      title: "Endless Entertainment",
      desc: "Enjoy a wide range of engaging activities designed to keep every team member energized and entertained.",
    },
    {
      id: 2,
      icon: "/assets/img/icon-2.png",
      title: "Team Synergy",
      desc: "Our activities are thoughtfully designed to encourage collaboration, communication, and trust among team members.",
    },
    {
      id: 3,
      icon: "/assets/img/icon-3.png",
      title: "Flexible Packages",
      desc: "We offer fully customizable packages tailored to your organization’s goals, team size, and budget.",
    },
  ];

  const swiperOptions = {
    spaceBetween: 30,
    speed: 2000,
    loop: true,
    modules: [Autoplay, Pagination, Navigation],
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".dot",
      clickable: true,
    },
    navigation: {
      nextEl: ".array-next",
      prevEl: ".array-prev",
    },
    breakpoints: {
      1399: { slidesPerView: 3 },
      1199: { slidesPerView: 3 },
      991: { slidesPerView: 2 },
      767: { slidesPerView: 2 },
      575: { slidesPerView: 1 },
      0: { slidesPerView: 1 },
    },
  };

  return (
    <>
      <div
        className="breadcrumb-wrapper bg-cover"
        style={{
          backgroundImage: `url(${
            packageData.banner || "/assets/img/breadcrumb-bg.jpg"
          })`,
        }}
      >
        <div className="shape-image float-bob-y">
          <Image
            src="/assets/img/vector.png"
            width={84}
            height={186}
            alt="img"
          />
        </div>
        <div className="container">
          <div className="breadcrumb-wrapper-items">
            <div className="page-heading">
              <div className="breadcrumb-sub-title">
                <h1 className="wow fadeInUp " data-wow-delay=".3s">
                  {packageData.title}
                </h1>
              </div>
              <ul
                className="breadcrumb-items wow fadeInUp"
                data-wow-delay=".5s"
              >
                <li>
                  <Link href={`/`}> Packages </Link>
                </li>
                <li>
                  <i className="fa-sharp fa-solid fa-slash-forward" />
                </li>
                <li>{packageData.title}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="container py-5 packagefulldetails">
        <div className="row">
          <div className="col-lg-7 col-md-6 col-sm-12 align-self-center">
            <h2 className="pb-4">{packageData.title}</h2>
            <div
              className="text-justify leading-relaxed pe-4"
              dangerouslySetInnerHTML={{ __html: packageData.description }}
            />
            <hr />
            <h5 className="rsrvtxt">To Reserve Contact</h5>
            <div className="d-flex">
              <div className="col-lg-6">
                <div className="contact-item">
                  <span className="icon-circle">
                    <i className="fa-solid fa-phone-volume" />
                  </span>

                  <div>
                    <p>
                      <a href="#" className="text-dark">
                        +91 9111111111
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="contact-item">
                  <span className="icon-circle">
                    <i className="fa-solid fa-envelope" />
                  </span>
                  <div>
                    <p>
                      <a href="#" className="text-dark">
                        niranjanbudi@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-md-6 col-sm-12">
            <img
              src={packageData.image || "/assets/img/faqbg.png"}
              width={542}
              height={650}
              alt="img"
              className="faqbg"
            />
          </div>
        </div>
      </div>
      <div className="container py-5 packagefulldetails">
        <div className="row">
          <div className="col-lg-5 col-md-6 col-sm-12">
            <img
              src={packageData.image || "/assets/img/faqbg.png"}
              width={542}
              height={650}
              alt="img"
              className="faqbg"
            />
          </div>
          <div className="col-lg-7 col-md-6 col-sm-12 align-self-center">
            <h2 className="pb-4 ps-4">{packageData.title}</h2>
            <div
              className="text-justify leading-relaxed ps-4"
              dangerouslySetInnerHTML={{ __html: packageData.description }}
            />

            <hr />
            <h5 className="rsrvtxt">To Reserve Contact</h5>
            <div className="d-flex">
              <div className="col-lg-6">
                <div className="contact-item">
                  <span className="icon-circle">
                    <i className="fa-solid fa-phone-volume" />
                  </span>

                  <div>
                    <p>
                      <a href="#" className="text-dark">
                        +91 9111111111
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="contact-item">
                  <span className="icon-circle">
                    <i className="fa-solid fa-envelope" />
                  </span>
                  <div>
                    <p>
                      <a href="#" className="text-dark">
                        niranjanbudi@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="container whychoosebox">
                <div className="row pb-4">
                    {whyoptions.map(whyitem => (
                        <div className="col-lg-4 col-md-6 col-sm-12" key={whyitem.id}>
                            <div className="why-box card mb-3">
                                <div className="card-body text-center">
                                    <div className="why-icon">
                                        <img src={whyitem.icon} alt={whyitem.title} width={64} height={64} className="mb-2" />
                                    </div>
                                    <div className="why-content">
                                        <h4>{whyitem.title}</h4>
                                        <p>{whyitem.desc}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div> */}
      {packageData.gallery && packageData.gallery.length > 0 && (
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="text-center">Gallery</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <Swiper {...swiperOptions} className="swiper service-slider">
                {packageData.gallery.map((img, index) => (
                  <SwiperSlide key={index} className="swiper-slide">
                    <div className="service-box-items">
                      <div className="service-thumb p-0">
                        <img
                          src={img}
                          width={346}
                          height={236}
                          alt={`Gallery image ${index + 1}`}
                          style={{ objectFit: "cover" }}
                        />
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="array-button d-flex gap-3 mb-4 justify-content-center mt-4">
                <button
                  className="array-prev snbp1"
                  style={{
                    backgroundColor: "var(--theme-color, #F55B1F)",
                    color: "white",
                    border: "none",
                  }}
                >
                  <i className="fa-regular fa-arrow-left-long"></i>
                </button>
                <button
                  className="array-next snbn1"
                  style={{
                    backgroundColor: "var(--theme-color, #F55B1F)",
                    color: "white",
                    border: "none",
                  }}
                >
                  <i className="fa-regular fa-arrow-right-long"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {packageData.faqs && packageData.faqs.length > 0 && (
        <section className="faq-section fix section-padding section-bg-2 bg-cover">
          <div className="container pb-4">
            <div className="row">
              <div className="col-lg-12">
                <h2 className="text-center pb-3">FAQ's</h2>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-8 faq-wrapper">
                <div className="faq-accordion">
                  <div className="accordion" id="accordion">
                    {packageData.faqs.map((faq, index) => (
                      <div
                        key={index}
                        className="accordion-item mb-3 wow fadeInUp"
                        data-wow-delay={`${0.2 * (index + 1)}s`}
                      >
                        <h5 className="accordion-header">
                          <button
                            className={`accordion-button ${
                              index === 0 ? "" : "collapsed"
                            }`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#faq${index}`}
                            aria-expanded={index === 0}
                            aria-controls={`faq${index}`}
                          >
                            {faq.question}
                          </button>
                        </h5>
                        <div
                          id={`faq${index}`}
                          className={`accordion-collapse collapse ${
                            index === 0 ? "show" : ""
                          }`}
                          data-bs-parent="#accordion"
                        >
                          <div className="accordion-body">{faq.answer}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
